import type { AABB, Vec2 } from '../geo/types';

/** Ordered, conservative candidates for the small floor patches. Empty cells allocate nothing
 * while terrain refinement samples the much larger surrounding city. */
export function floorCandidates<T extends { readonly bounds: AABB }>(items: readonly T[]) {
  const size = 32,
    columns = new Map<number, Map<number, T[]>>(),
    empty: readonly T[] = [];
  for (const item of items) {
    const b = item.bounds;
    for (let x = Math.floor((b.minX - 1e-8) / size); x <= Math.floor((b.maxX + 1e-8) / size); x++) {
      let column = columns.get(x);
      if (!column) columns.set(x, (column = new Map()));
      for (
        let y = Math.floor((b.minY - 1e-8) / size);
        y <= Math.floor((b.maxY + 1e-8) / size);
        y++
      ) {
        let cell = column.get(y);
        if (!cell) column.set(y, (cell = []));
        cell.push(item);
      }
    }
  }
  return (p: Vec2): readonly T[] =>
    columns.get(Math.floor(p[0] / size))?.get(Math.floor(p[1] / size)) ?? empty;
}
